module.exports = false;


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 1